import { useContext, useEffect, useState } from "react";

import { Container, Grid } from "@material-ui/core";
import { EditOutlined, Add } from "@material-ui/icons";

import Loading from "../../../components/basics/Loading";
import TextFieldErp from "../../../components/basics/TextFieldErp";
import Btn from "../../../components/buttons/Btn";
import HeaderModule from "../../../components/header/HeaderModule";

import { useHistory } from "react-router";

import {
  PrescricaoContext,
  PrescricaoContextProvider,
} from "./contexts/PrescricaoContext";
import { PainelContainer } from "./styles/Prescricao";
import { TableContent } from "../prescricao/styles/Prescricao";
import BigDataTable from "../../../components/tables/BigDataTable";
import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import { QueryParamsContext } from "../../../context/QueryParamsContext";

// falta criar a lógica de criação, edição de prescrição
// para cliente principal e dependentes
let typingTimer = null;
const Page = () => {
  const { loading } = useContext(PrescricaoContext);
  const { push } = useHistory();
  const [textFilter, setTextFilter] = useState("");
  const [paramsSend, setParamsSend] = useState("");
  const [reload] = useState(false);
  const { queryParams } = useContext(QueryParamsContext);

  const columnsHistory = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => {
        return (
          <SpeedDialErp
            actions={[
              {
                icon: <EditOutlined />,
                name: "Editar",
                action: () =>
                  push(
                    `cadastro?empresa_cnpj=${
                      queryParams?.empresa_cnpj || ""
                    }&empresa_id=${queryParams?.id || ""}`,
                    { item }
                  ),
              },
            ]}
          />
        );
      },
    },
    {
      id: "razao",
      label: "Cliente",
      flex: 1,
    },
    {
      id: "nomecolaborador",
      label: "Colaborador",
      flex: 1,
    },
    {
      id: "receita_data",
      label: "Data da Receita",
      align: "center",
      flex: 1,
      format: (item) => {
        return item?.receita_data?.split("-").reverse().join("/") || "";
      },
    },
  ];

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => {
      setParamsSend(`nomecolaborador=${textFilter}&nomecliente=${textFilter}`);
    }, 1500);
  }, [textFilter]);

  return (
    <>
      <Loading open={loading.screen} />
      <HeaderModule title="CADASTRO DE RECEITAS" />

      <PainelContainer />

      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid
            item
            container
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <Grid item xs={12} sm={12} md={7}>
              <TextFieldErp
                value={textFilter}
                setValue={setTextFilter}
                label="Busque por Cliente e Colaborador"
                variant="filled"
              />
            </Grid>
            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<Add />}
                onClick={() =>
                  push(
                    `cadastro?empresa_cnpj=${
                      queryParams?.empresa_cnpj || ""
                    }&empresa_id=${queryParams?.id || ""}`
                  )
                }
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TableContent>
              <Grid item xs={12}>
                <BigDataTable
                  columns={columnsHistory}
                  tableTitle=""
                  route="optica/prescricao/v1/filtrocolaboradorcliente"
                  reload={reload}
                  rawUrl={paramsSend}
                />
              </Grid>
            </TableContent>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

const PrescricaoListagem = () => (
  <PrescricaoContextProvider>
    <Page />
  </PrescricaoContextProvider>
);

export { PrescricaoListagem };
